export default __webpack_public_path__ + "1bd4ed3a6ef3c727582dc88ed2841a8b.png";